import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Building2, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../lib/api';
import toast from 'react-hot-toast';

const RegisterPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', password: '', tenantName: '', phone: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.register(form);
      await login(form.email, form.password);
      toast.success('Account created! Welcome to Winggs CRM.');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #EFF6FF 0%, #F5F3FF 100%)', padding: 16
    }}>
      <div style={{ width: '100%', maxWidth: 480 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 16,
            background: 'linear-gradient(135deg, #3B82F6, #8B5CF6)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px'
          }}>
            <Building2 size={28} color="#fff" />
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 800, color: '#111827' }}>Start Free Trial</h1>
          <p style={{ color: '#6B7280', marginTop: 6 }}>14 days free, no credit card required</p>
        </div>

        <div className="card">
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="form-group">
              <label className="form-label">Company Name *</label>
              <input type="text" className="form-input" placeholder="Winggs Rentals"
                value={form.tenantName} onChange={e => setForm(p => ({ ...p, tenantName: e.target.value }))} required />
            </div>
            <div className="form-grid form-grid-2">
              <div className="form-group">
                <label className="form-label">First Name *</label>
                <input type="text" className="form-input" placeholder="John"
                  value={form.firstName} onChange={e => setForm(p => ({ ...p, firstName: e.target.value }))} required />
              </div>
              <div className="form-group">
                <label className="form-label">Last Name *</label>
                <input type="text" className="form-input" placeholder="Doe"
                  value={form.lastName} onChange={e => setForm(p => ({ ...p, lastName: e.target.value }))} required />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Email *</label>
              <input type="email" className="form-input" placeholder="john@company.com"
                value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input type="tel" className="form-input" placeholder="+1 (555) 000-0000"
                value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="form-label">Password *</label>
              <div style={{ position: 'relative' }}>
                <input type={showPassword ? 'text' : 'password'} className="form-input" placeholder="Min. 6 characters"
                  value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                  required minLength={6} style={{ paddingRight: 40 }} />
                <button type="button" onClick={() => setShowPassword(p => !p)}
                  style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF' }}>
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-lg" disabled={loading}
              style={{ width: '100%', justifyContent: 'center', marginTop: 4 }}>
              {loading ? <><div className="spinner" style={{ borderTopColor: '#fff' }} /> Creating account...</> : 'Create Free Account'}
            </button>
          </form>

          <div style={{ marginTop: 20, padding: '12px 0', borderTop: '1px solid #F3F4F6', textAlign: 'center' }}>
            <p style={{ fontSize: 13, color: '#6B7280' }}>
              By registering, you agree to our Terms of Service and Privacy Policy.
            </p>
          </div>

          <p style={{ textAlign: 'center', marginTop: 12, fontSize: 14, color: '#6B7280' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#3B82F6', fontWeight: 500, textDecoration: 'none' }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
